import { useQuery } from '@hooks/reactQuery';

import { getAssetVisibilityRestricted } from '@api/assetVisibility';

import { extractQueryParams } from '@utils/common';

import { IAssetVisibilityRestricted } from '@interfaces/assets/assetVisibility';
import { IGetAssetVisibilityRestrictedDTO } from '@interfaces/assets/dto/assetVisibilityDTO';

import { EUserRoles } from '@enums/common';

import { ASSET_VISIBILITY_RESTRICTED } from '@constants/queryKeys';

interface IUseQueryAssetVisibilityRestrictedReturned {
	assetVisibilityRestricted: IAssetVisibilityRestricted[];
	countOfRecords: number;
	isLoadingAssetVisibilityRestricted: boolean;
}

export const useQueryAssetVisibilityRestricted = (
	params: IGetAssetVisibilityRestrictedDTO,
): IUseQueryAssetVisibilityRestrictedReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSET_VISIBILITY_RESTRICTED, params],
		allowedRoles: [
			EUserRoles.platformOwnerAdministrator,
			EUserRoles.assetOwnerOrganizationAdministrator,
		],
		queryFn: extractQueryParams(getAssetVisibilityRestricted),
		enabled: [!!params.id],
		refetchOnWindowFocus: false,
	});

	return {
		assetVisibilityRestricted: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingAssetVisibilityRestricted: isInitialLoading,
	};
};
